var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "friends-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "friends-main page-main"
  }, [_c('div', {
    staticClass: "friends-total"
  }, [_c('div', {
    staticClass: "friends-total__title"
  }, [_vm._v("Invite")]), _c('div', {
    staticClass: "friends-total__price"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.userInfo.invite_reward_coin)))])]), _c('div', {
    staticClass: "friends-intro"
  }, [_c('div', {
    staticClass: "friends-intro-item",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/invite-gift-1.jpg`)}) center/100% 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "friends-intro-main"
  }, [_c('div', {
    staticClass: "friends-intro__price"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
      "alt": ""
    }
  }), _vm._v("+" + _vm._s(_vm.fmt_pre(_vm.settingInfo?.reward?.invite?.normal?.coin)))]), _c('div', {
    staticClass: "friends-intro__label"
  }, [_vm._v("Invited a friend")])])]), _c('div', {
    staticClass: "friends-intro-item",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/invite-gift-2.jpg`)}) center/100% 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "friends-intro-main"
  }, [_c('div', {
    staticClass: "friends-intro__price"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
      "alt": ""
    }
  }), _vm._v("+" + _vm._s(_vm.fmt_pre(_vm.settingInfo?.reward?.nextInvite?.normal?.coin)))]), _vm._m(0)])])]), _c('div', {
    staticClass: "friends-btns"
  }, [_c('div', {
    staticClass: "btn-invite",
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("Invite")]), _c('div', {
    staticClass: "btn-copy",
    on: {
      "click": _vm.onCopy
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1)]), _c('div', {
    staticClass: "friends-list"
  }, [_c('div', {
    staticClass: "friends__title"
  }, [_vm._v("My invitation (" + _vm._s(_vm.fmt_pre(_vm.userInfo.ref_count)) + ")")]), _vm.friendList ? [_vm.friendList.length > 0 ? _vm._l(_vm.friendList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "friends-item"
    }, [_c('div', {
      staticClass: "friends__head"
    }, [item.avatar ? _c('img', {
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }) : _c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "friends__name"
    }, [_vm._v(_vm._s(item.nickname))]), _c('div', {
      staticClass: "friends__price"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm.fmt_pre(item.coin)))])]);
  }) : _vm._e()] : _vm._e()], 2)]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "friends-intro__label"
  }, [_vm._v(" Friend invited another"), _c('br'), _vm._v(" friend ")]);
}];
export { render, staticRenderFns };